'use strict';

import { ferry } from "../ferry/ferry";
import { oauth as fundusOauth } from "../../fundus/oauth";
import { notify } from '../../services/notify/notify';


declare global {
    interface Window {
        oauthSuccessCallback: () => void;
    }
}

export type Tokens = {
    [service: string]: boolean;
};

class oauthFactory {
    tokens: Tokens;

    constructor() {
        this.tokens = undefined;
    }

    loadTokens() {
        if (this.tokens !== undefined) {
            return Promise.resolve(this.tokens);
        } else {
            return ferry.select<fundusOauth.my_tokens>('oauth.my_tokens', ['service']).then((toks) => {
                this.tokens = {};
                toks.forEach((tok) => {
                    this.tokens[tok.service] = true;
                });
                return Promise.resolve(this.tokens);
            });
        }
    }

    oAuthConnect(service: string, single_tab?: 'required'|'allowed', redirect?: string) {
        const t_ref = this;
        return new Promise((resolve, reject) => {
            let request_token: string;
            window.oauthSuccessCallback = () => {
                // we actually don't want to reference "this" here since we're assigning this function to window
                if (t_ref.tokens) {
                    t_ref.tokens[service] = true;
                }
                resolve({service, request_token});
            };
            let tab: Window;
            if (single_tab === "required") {
                tab = window;
            } else {
                tab = window.open('', '_blank');
                if (!tab) {
                    if (single_tab === "allowed") {
                        tab = window;
                    } else {
                        notify.error("pop up blocked");
                    }
                }
            }
            const initParams: {
                redirect?: string
            } = {};
            if (redirect) {
                initParams.redirect = redirect;
            }
            ferry.call(`/oauth/init/${service}`, initParams).then((data) => {
                request_token = data.request_token;
                try {
                    tab.location.href = data.authURL;
                }
                catch (e) {
                    console.error(e);
                    throw 'pop up blocked';
                }
            }).catch((err) => {
                reject(err);
            });
        });
    }
}

export const oauth = new oauthFactory();



// WEBPACK FOOTER //
// ./_src/services/oauth/oauth.ts